import { ContactApi } from "src/api/generated/erp/contacts/api/contactApi.ts";
import { ContactUpdateService_UpdateRequest } from "src/api/generated/erp/contacts/service/contactUpdateService.ts";
import { Contact } from "src/api/generated/erp/db/types/tables/contact.ts";
import { ContactConnectedItemType } from "src/api/generated/erp/db/types/enums/contactConnectedItemType.ts";
import { SalesLeadContactsApi } from "src/api/generated/erp/sales/crm/salesLeads/api/salesLeadContactsApi.ts";

export interface ContactEndpoints {
	getContacts: () => Promise<Contact[]>;
	insert: (contact: Contact) => Promise<number>;
	update: (contact: ContactUpdateService_UpdateRequest) => Promise<number>;
	delete: (contactId: number) => Promise<void>;
}

/** Sales lead contacts use their own endpoints, which enforce sales lead permissions. */
export function getContactEndpoints(
	connectedItemType: ContactConnectedItemType,
	connectedItemId: number,
): ContactEndpoints {
	if (connectedItemType === "SALES_LEAD") {
		return {
			getContacts: () => SalesLeadContactsApi.getContacts({ salesLeadId: connectedItemId }),
			insert: (contact) => SalesLeadContactsApi.insert({ salesLeadId: connectedItemId, contact }),
			update: (contact) => SalesLeadContactsApi.update({ contact }),
			delete: (contactId) => SalesLeadContactsApi.delete_({ contactId }),
		};
	}
	return {
		getContacts: () => ContactApi.getItemContacts({ connectedItemType, connectedItemId }),
		insert: (contact) => ContactApi.insert({ contact }),
		update: (contact) => ContactApi.update({ contact }),
		delete: (contactId) => ContactApi.delete_({ contactId }),
	};
}
